'use client';
import { setToString } from '../../../core/utilities/set.utils.js';
import { removeCoreProps } from './core.utils.js';
import { renderElem } from './render-element.util.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function RenderComp({ root: n, props: c, propKeysToRemove: p, forwardedRef: i, classNames: s, children: u }) {
    let b = processStyleProps(c, s), f = c.className;
    f && b.add(f);
    let l = _object_spread_props(_object_spread({}, removeCoreProps(c)), {
        className: setToString(b)
    });
    return renderElem({
        root: n,
        ref: i,
        renderProps: c,
        props: l,
        children: u
    });
}

export { RenderComp };
